import React, { FC, SVGProps } from "react";

// Using FC with SVGProps so you can pass standard SVG attributes like className, width, height, etc.
export const IconStar: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
	viewBox="0 0 24 24"
	fill="none"
	stroke="currentColor"
	strokeWidth={2}
	strokeLinecap="round"
	strokeLinejoin="round"
	className="feather feather-star"
	{...props}
	>
		<title>Star</title>
		<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
	</svg>
);

export const IconGitHub: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
	xmlns="http://www.w3.org/2000/svg"
	role="img"
	viewBox="0 0 24 24"
	fill="none"
	stroke="currentColor"
	strokeWidth={2}
	strokeLinecap="round"
	strokeLinejoin="round"
	className="feather feather-github"
	{...props}
	>
		<title>GitHub</title>
		<path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
	</svg>
);

export const IconFork: FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="feather feather-git-branch"
        {...props}
    >
        <title>Git Fork</title>
        <line x1="6" y1="3" x2="6" y2="15"></line>
        <circle cx="18" cy="6" r="3"></circle>
        <circle cx="6" cy="18" r="3"></circle>
        <path d="M18 9a9 9 0 0 1-9 9"></path>
    </svg>
);

export const IconLinkedin: FC<SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-linkedin">
		<title>LinkedIn</title>
		<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
		<rect x="2" y="9" width="4" height="12"></rect>
		<circle cx="4" cy="4" r="2"></circle>
  </svg>
);

export const IconExternal: FC<SVGProps<SVGSVGElement>> = () => (
	<svg
	xmlns="http://www.w3.org/2000/svg"
	role="img"
	viewBox="0 0 24 24"
	fill="none"
	stroke="currentColor"
	strokeWidth="2"
	strokeLinecap="round"
	strokeLinejoin="round"
	className="feather feather-external-link">
		<title>External Link</title>
		<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
		<polyline points="15 3 21 3 21 9"></polyline>
		<line x1="10" y1="14" x2="21" y2="3"></line>
	</svg>
);